import Icon, { IconNames } from 'components/Icon/Icon';
import { useMemo } from 'react';
import dayjs from 'dayjs'; // Import dayjs
import { Event } from 'types/Event';
import { getEventColors } from 'common/components/Calendar/EventColors';

export type EventRowItemProps = {
  item: Event;
  showDate: boolean;
  outlined?: boolean;
  handleEventSelect?: (item: Event) => void;
  isCurrentOrNextEvent?: boolean;
  className?: string;
};

export const EventRowItem = ({
  item,
  showDate = true,
  outlined,
  handleEventSelect,
  isCurrentOrNextEvent,
  className = '',
}: EventRowItemProps) => {
  const onItemPressed = () => {
    handleEventSelect?.(item);
  };

  const startDate = dayjs(item.start);

  const date = startDate.format('D');
  const month = startDate.format('MMM').toLowerCase();
  const time = startDate.format('HH[h]mm');

  const { textColor, border, backgroundColor, iconName } = useMemo(
    () => getEventColors({ event: item, outlined }),
    []
  );

  return (
    <div className={className}>
      {isCurrentOrNextEvent && (
        <div className="relative w-full mb-4 mt-1">
          <div className="absolute inset-0 flex items-center">
            <div className="h-1 bg-teal-500 flex-grow rounded-full" />
            <div className="px-4 text-sm font-medium text-teal-500">Maintenant</div>
            <div className="h-1 bg-teal-500 flex-grow rounded-full" />
          </div>
        </div>
      )}
      <div className={`flex flex-row items-start`}>
        {showDate ? (
          <div className="w-20 mt-0 flex flex-row gap-1 items-end pr-4">
            <div className="text-xl w-6 font-bold text-right">{String(date).padStart(2, '0')}</div>
            <div className="text-sm w-8  pb-0.5">{month}</div>
          </div>
        ) : (
          <div className="w-20 flex" />
        )}
        <div
          className={`flex-1 flex-col mb-3 rounded-lg pt-0 px-3 cursor-pointer ${border} ${backgroundColor} ${
            item.meeting?.status === 'cancelled' && 'opacity-70'
          }`}
          style={{ gap: 4 }}
          onClick={onItemPressed}
        >
          <div className="flex flex-row items-center justify-between" style={{ gap: 8 }}>
            <div className="flex flex-row items-center gap-4">
              <div className={`text-lg ${textColor} font-bold w-16`}>{time}</div>
              <Icon
                name={item.meeting?.modality === 'phone' ? 'PhoneIcon' : 'UsersIcon'}
                className={`h-6 w-6 ${textColor}`}
              />
              <div className={`text-lg ${textColor} font-bold flex-1`}>{item.title}</div>
            </div>

            <div className="flex flex-row items-center">
              <Icon name={iconName} className={`h-6 w-6 ${textColor}`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
